// @flow

import { type PaymentMethod, type PaymentMethodCode } from '@tectonics/prs/payment-method';
import { type PaymentSpec } from './types';

export function getPaymentMethodByCode(code: PaymentMethodCode, spec: PaymentSpec): ?PaymentMethod {
  return spec.paymentMethods.find(it => it.code === code);
}

export function getSafePaymentMethodByCode(code: PaymentMethodCode, spec: PaymentSpec): PaymentMethod {
  const paymentMethod = getPaymentMethodByCode(code, spec);
  if (!paymentMethod) {
    throw new Error(`getSafePaymentMethodByCode: there is no payment method code "${code}" in the spec.`);
  }
  return paymentMethod;
}
